import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const includes = ['5 Tomos completos (PDF)', '3 Bonos exclusivos (PDF)', 'Acceso inmediato', 'Descarga ilimitada'];
export function OfferSection() {
  return <section id="oferta" className="w-full bg-white py-8 md:py-14 px-4" data-id="element-110">
      <div className="max-w-3xl mx-auto" data-id="element-111">
        <div className="bg-gradient-to-b from-[#F8F9FA] to-white p-6 md:p-10 rounded-2xl border-2 border-[#FF6B00] shadow-xl" data-id="element-112">
          <h2 className="text-2xl md:text-4xl font-bold text-[#1A1A2E] text-center mb-6" data-id="element-113">
            ¡OBTÉN TU MEGAPACK AHORA!
          </h2>

          <div className="mb-6" data-id="element-114">
            <h3 className="text-lg font-semibold text-[#1A1A2E] mb-3 text-center" data-id="element-115">
              Qué te llevas:
            </h3>
            <ul className="space-y-2" data-id="element-116">
              {includes.map((item, index) => <li key={index} className="flex items-center gap-3 justify-center" data-id="element-117">
                  <CheckIcon className="w-5 h-5 text-[#22C55E]" data-id="element-118" />
                  <span className="text-[#4A4A5A]" data-id="element-119">{item}</span>
                </li>)}
            </ul>
          </div>

          <div className="text-center mb-6" data-id="element-120">
            <p className="text-lg text-[#4A4A5A] mb-1" data-id="element-121">Precio comparación:</p>
            <p className="text-2xl text-[#EF4444] line-through font-semibold mb-3" data-id="element-122">
              ARS $49.990
            </p>
            <p className="text-lg text-[#4A4A5A] mb-1" data-id="element-123">Precio de hoy:</p>
            <p className="text-5xl md:text-6xl font-extrabold text-[#22C55E] mb-5" data-id="element-124">
              ARS $19.990
            </p>
          </div>

          <div className="flex justify-center" data-id="element-125">
            <a href="https://checkout2.ebookify.online/cart/42542749417570:1" target="_blank" rel="noopener noreferrer" className="relative w-full md:w-auto px-8 py-5 bg-[#FF6B00] hover:bg-[#E55A00] text-white font-bold text-lg md:text-xl rounded-xl shadow-lg transition-colors duration-200 cursor-pointer text-center inline-block animate-pulse-glow" data-id="element-126">
              QUIERO EL MEGAPACK AHORA (ARS $19.990)
            </a>
          </div>
        </div>
      </div>
    </section>;
}